import { render } from "./ProductManager.vue?vue&type=template&id=03c5717a&scoped=true"
import script from "./ProductManager.vue?vue&type=script&lang=js"
export * from "./ProductManager.vue?vue&type=script&lang=js"

import "./ProductManager.vue?vue&type=style&index=0&id=03c5717a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c5717a"]])

export default __exports__